import React, { useRef, memo } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function EmotionalIntro() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[#0a0a0a] py-24 px-6" data-id="element-81">
      <div className="max-w-3xl mx-auto text-center" data-id="element-82">
        <motion.div initial={{
        scaleX: 0
      }} animate={isInView ? {
        scaleX: 1
      } : {}} transition={{
        duration: 0.8
      }} className="gold-divider mb-12" data-id="element-83" />

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.9,
        delay: 0.2
      }} className="text-2xl md:text-3xl leading-relaxed text-[#E8D5B0] font-light" style={{
        fontFamily: 'Playfair Display, serif',
        fontStyle: 'italic'
      }} data-id="element-84">
          Hay historias que el mundo prefiere ignorar.
          <br data-id="element-85" />
          <span className="text-[#F5F0E8] font-normal not-italic" data-id="element-86">
            Historias de madres que vieron a sus hijos partir sin saber si
            volverían.
          </span>{' '}
          De familias separadas por miles de kilómetros. De un país que fue
          arrebatado a su gente en silencio, mientras el resto del mundo miraba
          hacia otro lado.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.9,
        delay: 0.4
      }} className="mt-8 text-xl md:text-2xl leading-relaxed text-[#9A9080]" style={{
        fontFamily: 'Playfair Display, serif',
        fontStyle: 'italic'
      }} data-id="element-87">
          Este libro existe porque esas historias{' '}
          <span className="text-[#CF9B2E]" data-id="element-88">merecen ser contadas.</span> Porque
          la memoria es el único territorio que nadie puede quitarnos.
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        delay: 0.7
      }} className="mt-12" data-id="element-89">
          <div className="gold-divider" data-id="element-90" />
        </motion.div>
      </div>
    </section>;
}